// Firebase imports
// import { collection, getDocs } from "firebase/firestore";
import { doc, getDoc } from "firebase/firestore";

// Firebase wrappers
import firebaseSetDocWrapper from "../wrappers/firebase/firebaseSetDocWrapper";

// Constants
// import { QUESTIONS } from "../../constants";
import { QUESTIONSIDS, QUESTIONSIDS_DOCID } from "../../constants";

export default async function initializeUser(db, collectionName, user) {
  console.log("In initializeUser...");

  let unansweredQnsIDs = []; // unansweredQnsIDs will contain doc ids of each question

  const docRef = doc(db, QUESTIONSIDS, QUESTIONSIDS_DOCID);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    unansweredQnsIDs = [...docSnap.data().questionsIDsArr];
    console.log(
      "Document data copied to unansweredQnsIDs:",
      unansweredQnsIDs.length
    );
  } else {
    // docSnap.data() will be undefined in this case
    console.log("No such document!");
  }

  console.log("Now creating user in Firestore with various info.");

  let userDocumentID = user.email; // each user is a document. user's email will be used as user's document ID
  let userData = {
    totalQnsInMainCollection: unansweredQnsIDs.length,
    unansweredQnsIDs, //initially a copy of master database, this will decrement as the user keeps giving correct answers
    totalCorrect: 0, //incremented each time a user answers correctly
    totalAttempts: 0, //incremented each time a user attempts question
    quizCompletedOn: null, //date and time user completed the quiz
    certificate: {
      issued: false,
      issuedTo: null, //display name on certificate
      dateIssued: null,
      url: null //if issued, this will store the link on Firebase cloud storage
    }
  };
  firebaseSetDocWrapper(db, collectionName, userDocumentID, userData);
  console.log("Back in initializeUser from firebaseSetDocWrapper.");
}
